module.exports = __webpack_public_path__ + "img/concept-cicd.f59fb9dc.svg";